module.exports = __webpack_public_path__ + "static/media/fruits_3.351f6e36.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_3.csv
// module id = 695
// module chunks = 0